import { useEffect, useState } from "react";

declare global {
  interface Window {
    ymaps: any;
  }
}

export const useYandexMaps = (apiKey: string) => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const scriptId = "yandex-maps-script";

    if (window.ymaps) {
      window.ymaps.ready(() => setReady(true));
      return;
    }

    const existingScript = document.getElementById(scriptId);

    if (existingScript) {
      const checkReady = setInterval(() => {
        if (window.ymaps) {
          window.ymaps.ready(() => setReady(true));
          clearInterval(checkReady);
        }
      }, 100);

      return () => clearInterval(checkReady);
    }

    const script = document.createElement("script");
    script.id = scriptId;
    script.src = `https://api-maps.yandex.ru/2.1/?apikey=${apiKey}&lang=ru_RU`;
    script.async = true;

    script.onload = () => {
      window.ymaps.ready(() => setReady(true));
    };

    document.body.appendChild(script);
  }, [apiKey]);

  return ready;
};